import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The logo, choosing its own variant — requirement 6.11.
 *
 * "WHEN the logo is rendered on a surface THEN the variant appropriate to that surface SHALL be
 * selected automatically, and a variant whose mark is illegible on that surface SHALL NOT be used."
 * So the component reads the active theme rather than taking a filename, and the surface matrix in
 * `assets.ts` decides. The mark is navy in all four originals and reaches 1.67:1 against black, so
 * every dark surface gets the wordmark crop and no call site has to know that.
 *
 * `surface` is an escape hatch for the case the theme cannot answer: a dark hero band inside the
 * light dashboard is a dark surface whatever `<html>` says. It still goes through the matrix, so it
 * selects rather than names a file.
 *
 * `<picture>` rather than a plain `<img>` because AVIF and WebP save real bytes on flat brand
 * artwork and the PNG has to stay for anything that cannot read either. `width`/`height` come from the
 * measured aspect ratio so the box is reserved before the file arrives.
 */
import {} from 'react';
import { useTheme } from '../theme/useTheme.js';
import { assetSrcSet, assetUrl, logoVariants, surfaceMatrix, } from './assets.js';
export const Logo = ({ orientation = 'horizontal', surface, width = 180, alt, ...imgProps }) => {
    const { theme } = useTheme();
    const variant = logoVariants[surfaceMatrix[surface ?? theme][orientation]];
    return (_jsxs("picture", { children: [_jsx("source", { type: "image/avif", srcSet: assetSrcSet(variant, 'avif'), sizes: `${String(width)}px` }), _jsx("source", { type: "image/webp", srcSet: assetSrcSet(variant, 'webp'), sizes: `${String(width)}px` }), _jsx("img", { ...imgProps, src: assetUrl(variant, variant.widths[1], 'png'), srcSet: assetSrcSet(variant, 'png'), sizes: `${String(width)}px`, width: width, height: Math.round(width / variant.aspectRatio), alt: alt ?? variant.alt, decoding: "async" })] }));
};
//# sourceMappingURL=Logo.js.map